import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import {
  Paper, FormControl, Button, TextField, Typography,
} from '@material-ui/core';

import Actions from '../actions';

class PlanAssignmentForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      field: '',
    };
  }

  // componentDidMount() {
  //     this.props.fetchUsers();
  // }

    handleChange = (event) => {
      this.setState({ plan: event.target.value });
    };

    handleUserChange = (event) => {
      this.setState({ user: event.target.value });
    };

    handleFieldChange = (e) => {
      this.setState({ field: e.target.value });
    }

    onSubmit = (e) => {
      e.preventDefault();
      this.props.fetchUser(this.state.field)
        .then(() => {
          const { user } = this.props;
          if (user) this.setState((prevState) => { return { users: [...prevState.users, user], field: '' }; });
          else alert('User not found!');
        });
    }

    assignPlan = () => {
      // e.preventDefault();
      const { plan } = this.props;
      const promises = this.state.users.map((user) => { return this.props.assignPlan(user._id, plan._id); });
      Promise.all(promises).then(() => { return alert(JSON.stringify({ ...this.state, plan: plan._id })); });
    }

    render() {
      const { plan } = this.props;
      return (
        <>
          <h3 style={{ textAlign: 'right' }}>{plan && plan.name}</h3>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Paper style={{ width: '500px', padding: '50px' }}>
              <h3 style={{ marginTop: 0 }}>Assign Plan</h3>
              <form onSubmit={(e) => { return this.onSubmit(e); }}>
                <FormControl fullWidth>
                  <TextField
                    name="field"
                    label="Email or Phone or UID or Name"
                    value={this.state.field}
                    onChange={(e) => { this.handleFieldChange(e); }}
                  />
                </FormControl>
                <FormControl fullWidth style={{ marginTop: '20px' }}>
                  <Button variant="contained" type="submit" color="primary">Search User</Button>
                </FormControl>
              </form>
              <div style={{ marginTop: 20 }}>
                {
                        this.state.users.map((user, index) => {
                          return (
                            // eslint-disable-next-line react/no-array-index-key
                            <Typography key={index}>
                              {index + 1}
                              .
                              {' '}
                              {user.email || user.phone || user.name}
                            </Typography>
                          );
                        })
                    }
              </div>
              <form onSubmit={(e) => { return this.assignPlan(e); }}>
                <FormControl style={{ marginTop: '40px' }}>
                  <Button variant="contained" type="submit" color="primary">
                    {
                                        this.state.users.length > 0
                                          ? (<span>Assign Plan</span>) : (<span>Skip</span>)
                                    }
                  </Button>
                </FormControl>
              </form>
            </Paper>
          </div>
        </>
      );
    }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

function mapStateToProps(state) {
  return {
    user: state.user.data,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PlanAssignmentForm));
